import { HttpParams } from '@angular/common/http';
import {
  DsmCatalogContext,
  DsmCatalogOptionScope,
  DsmCatalogPdfQuery,
  DsmCatalogQuery
} from '../models/dsm-options-catalog.models';

/**
 * The catalog query as the API binds it: one key per list value (`categoryIds=a&categoryIds=b`),
 * and nothing for empty lists, include flags that are off or the All scope — those are the API's
 * defaults, so leaving them out keeps the URL short.
 */
export function toCatalogHttpParams(query: DsmCatalogQuery | DsmCatalogPdfQuery): HttpParams {
  let params = new HttpParams()
    .set('projectId', query.projectId)
    .set('modelId', query.modelId)
    .set('elevationId', query.elevationId);

  const lists: [string, string[]][] = [
    ['categoryIds', query.categoryIds],
    ['subcategoryIds', query.subcategoryIds],
    ['roomIds', query.roomIds],
    ['productTypeIds', query.productTypeIds],
    ['catalogChannels', query.catalogChannels],
    ['modelElevations', query.modelElevations]
  ];
  lists.forEach(([key, values]) => values.forEach(value => (params = params.append(key, value))));

  if (query.optionScope !== DsmCatalogOptionScope.All) params = params.set('optionScope', query.optionScope);

  const flags: [string, boolean | undefined][] = [
    ['includeRooms', query.includeRooms],
    ['includeAttributes', query.includeAttributes],
    ['includeImages', query.includeImages],
    ['hideUnitPrices', (query as DsmCatalogPdfQuery).hideUnitPrices],
    ['hideExtendedPrices', (query as DsmCatalogPdfQuery).hideExtendedPrices]
  ];
  flags.forEach(([key, on]) => on && (params = params.set(key, 'true')));

  return params;
}

/**
 * The API's own PDF name (`{Project} {Lot | Model-Elevation | N Models} Options Catalog {yyyy-MM-dd}.pdf`), for
 * when CORS hides Content-Disposition. `homes` are the plans printed, the first being the context.
 */
export function toCatalogPdfFileName(homes: DsmCatalogContext[], date: Date): string {
  const [home] = homes;
  const part = (value: string) => value.replace(/[^A-Za-z0-9-]+/g, ' ').trim();
  const printed = home.lotNo
    ? home.lotNo
    : homes.length === 1
      ? `${home.modelName}-${home.elevationCode}`
      : `${homes.length} Models`;
  const day = [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(n => String(n).padStart(2, '0')).join('-');

  return `${part(home.projectName)} ${part(printed)} Options Catalog ${day}.pdf`;
}
